module.exports = __webpack_public_path__ + "static/thumb-8e6a47d680201245f7a4a04f010fbb59.png";